/**
 * Every external system the app can render, keyed by the string stored in
 * `collection.provider_key`.
 *
 * Adding one is an entry here and a module beside it. Nothing else in the app
 * -- not the loader, not the sidebar, not the create dialog -- names a provider
 * directly.
 */

import { ExternalProviderModule } from "./types";
import { gmail } from "./gmail";

export const providerModules: Record<string, ExternalProviderModule> = {
  [gmail.key]: gmail,
};

/** In the order the create-collection library offers them. */
export const providerLibrary: ExternalProviderModule[] =
  Object.values(providerModules);

export function getProvider(
  key: string | null | undefined,
): ExternalProviderModule | null {
  if (!key) return null;
  return providerModules[key] ?? null;
}

/**
 * Which systems a set of provider keys needs a grant on. A collection and its
 * subcollections share one, which is why connecting is a whole-tree action.
 */
export function systemsFor(keys: string[]): string[] {
  const systems: string[] = [];
  for (const key of keys) {
    const provider = getProvider(key);
    if (provider && !systems.includes(provider.systemId)) {
      systems.push(provider.systemId);
    }
  }
  return systems;
}
